<template>
  <div>
    <div class="vx-row">
        <!-- COL 1 -->
        <div class="vx-col w-full lg:w-3/3">
          <div v-if="getApp.item" class="uuuuuuuuuuuuuuuuuuuuu">
            <div>
              <div class="post-header flex justify-between mb-4">
                <div class="flex items-center">
                  <div class="ml-4">
                    <h4>Niveau : <b style="color: #6058bb;">{{ getApp.item.level.name }}</b> </h4>
                    <h4>Points : <b style="color: #6058bb;">{{ getApp.item.points }}</b> </h4><br>
                    <h4>Instruction :</h4>
                    <p style="color: green;"> {{ getApp.item.instruction }} </p><br>
                    <h4>Question :</h4>
                    <p style="color: green;"> {{ getApp.item.content }} </p><br>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="getApp.item && comments.length" class="uuuuuuuuuuuuuuuuuuuuu">
            <div v-for="(item, uio) in comments" :key="item.slug">
              <div class="post-header flex justify-between mb-4">
                <div class="flex items-center">
                  <div>
                    <vs-avatar class="m-0" :src="$store.state.AppActiveUser.photoURL" size="45px"></vs-avatar>
                  </div>
                  <div class="ml-4">
                    <h6>{{ item.user ? item.user.lastname : '' }} - {{ item.user ? item.user.firstname : '' }}</h6>
                    <small>Mise en ligne: {{ item.created_at }}</small>
                  </div>
                </div>
              </div>

              <div class="post-content contentOTDS">
                <p v-html="item.comment"></p>
              </div>
              <vs-divider v-if="uio !== (comments.length - 1)" size="20" style="height: 1px" background="primary"></vs-divider>
            </div>
          </div>
          <!-- <div v-if="getApp.item && !getApp.item.alert && affiche" class="uuuuuuuuuuuuuuuuuuuuu">
            <div>
              <v-select class="w-full" label="content" multiple v-model="input.country" :options="getApp.item.choices"></v-select>
            </div>
            <br/>
            <vs-button color="primary" @click="submitData" type="border">Valider</vs-button>
          </div> -->
        </div>
    </div>
  </div>
</template>

<script>
var base_self

export default {
  props: {
    base: ''
  },
  components: {
  },
  watch: {
    category () {
      base_self.getDatas()
    },
    messujets () {
      base_self.getDatas()
    }
  },
  data() {
    return {
      autorise: false,
      evaluation: '',
      input: {
        comment: ''
      },
      messujets: false,
      comments: [],
      datas: [],
      category: [],
      categories: [],
      url: '/forum/subjects'
    };
  },
  computed: {
    affiche () {
      return !window.getApp.isAdmin() && base_self.autorise;
    },
    getApp () {
      return window.getApp
    },
    realBase () {
      return base_self
    }
  },
  methods: {
    submitData() {
     /*  let element = {
        "user":2,
        "email":"dj_ramatoulay@eba.com",
        "evaluation":3,
        "responses":[
          {
            "question":1,
            "answers": ["toto", "tata"]
          },
          {
            "question":2,
            "answers":["je suis docteur"]
          },
          {
            "question":4,
            "answers":["pBMbxrwBna"]
          }
        ]
      }; */
      
      base_self.$vs.loading()
      
      base_self.$http.post('/forum/comments', { comment: base_self.input.comment, subject: window.getApp.item.id })
      .then((response) => { window.getApp.success("Le commentaire est enrégistrer avec succès.", response); base_self.input.comment = '' })
      .catch((error) => { window.getApp.error(error) })
    }
  },
  created() {
    base_self = this
  },
  destroyed: function () {
    // window.getApp.item = '';
    base_self.$router.push('/evaluation/questionnaire/show').catch(() => {})
  },
  mounted() {
    base_self.evaluation = JSON.parse(localStorage.getItem('evaluation_All_otd'));

    base_self.evaluation.evaluation_teams.forEach(element => {
      if (element.team_id === this.$store.state.AppActiveUser.team_id) {
        base_self.autorise = true;
        console.log('base_self.autorise: ', base_self.autorise);
      }
    });

    console.log('base_self.evaluation: ', base_self.evaluation)
    console.log('this.$store.state.AppActiveUser: ', this.$store.state.AppActiveUser)
  }
};
</script>

<style>
.ddddddddd {
  background-color: white;
  border: 1px solid #c1c1c1;
  border-radius: 5px 5px;
  margin: 5px;
}
.uuuuuuuuuuuuuuuuuuuuu {
  background-color: white;
  border: 1px solid #c1c1c1;
  border-radius: 5px 5px;
  margin: 5px;
  padding: 10px;
}
.contentOTD{
  border: 2px solid #c1c1c1;
  border-radius: 20px 0px 20px 0px;
  padding: 20px;
  background-color: #eaf1ff;
}
.contentOTDS{
  border: 2px solid #c1c1c1;
  border-radius: 0px 20px 0px 20px;
  padding: 20px;
  background-color: #e1ffd5;
}
</style>